import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

const routes = [
  {
    path: '*',
    name: 'error404',
    component: () => import(/* webpackChunkName: "error404" */ './views/Error404'),
  },

  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
  },

  {
    path: '/',
    name: 'home',
    redirect: () => {
      if (store.getters['auth/isAdmin']) {
        return { name: 'panel' };
      }

      return { name: 'visitsSchedule' };
    },
  },
  {
    path: '/panel',
    name: 'panel',
    component: () => import(/* webpackChunkName: "panel" */ './views/PantallaInicio'),
  },
  {
    path: '/encargos',
    name: 'charges',
    component: () => import(/* webpackChunkName: "charges" */ './views/Charges/List'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/encargos/anulados',
    name: 'encargos-anulados',
    component: () => import(/* webpackChunkName: "charges" */ './views/Charges/AnuladosList'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },

  },

  {
    path: '/encargo/:id?',
    name: 'charge',
    props: true,
    component: () => import(/* webpackChunkName: "charge" */ './views/Charges/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },

  {
    path: '/sucursales',
    name: 'branches',
    component: () => import(/* webpackChunkName: "branches" */ './views/Branches/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/sucursal/:id?',
    name: 'branch',
    props: true,
    component: () => import(/* webpackChunkName: "branch" */ './views/Branches/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/solicitantes',
    name: 'applicants',
    component: () => import(/* webpackChunkName: "applicants" */ './views/Applicants/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/solicitante/:id?',
    name: 'applicant',
    props: true,
    component: () => import(/* webpackChunkName: "applicant" */ './views/Applicants/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/delegaciones',
    name: 'delegations',
    component: () => import(/* webpackChunkName: "delegations" */ './views/Delegations/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/delegacion/:id?',
    name: 'delegation',
    props: true,
    component: () => import(/* webpackChunkName: "delegation" */ './views/Delegations/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/trabajos',
    name: 'jobs',
    component: () => import(/* webpackChunkName: "jobs" */ './views/Jobs/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/trabajo/:id?',
    name: 'job',
    props: true,
    component: () => import(/* webpackChunkName: "job" */ './views/Jobs/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  // {
  //   path: '/asignacion-visitas',
  //   name: 'visitAssignments',
  //   component: () =>
  //     import(/* webpackChunkName: "visitAssignments" */ './views/VisitAssignments'),
  //   meta: {
  //     auth: true,
  //     roles: ['admin'],
  //   },
  // },

  // {
  //   path: '/asignacion-salidas',
  //   name: 'salidaAssignments',
  //   component: () =>
  //     import(/* webpackChunkName: "salidaAssignments" */ './views/SalidaAssignments'),
  //   meta: {
  //     auth: true,
  //     roles: ['admin'],
  //   },
  // },

  {
    path: '/inmuebles',
    name: 'properties',
    component: () => import(/* webpackChunkName: "propertyType" */ './views/PropertyTypes/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/inmueble/:id?',
    name: 'property',
    props: true,
    component: () => import(/* webpackChunkName: "propertyTypes" */ './views/PropertyTypes/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/usuarios',
    name: 'tasadores',
    component: () => import(/* webpackChunkName: "assessors" */ './views/Assessors/List'),
    meta: {
      auth: true,
      roles: ['admin'],
    },
  },

  {
    path: '/usuario/:id?',
    name: 'tasador',
    props: true,
    component: () => import(/* webpackChunkName: "assessor" */ './views/Assessors/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/comerciales',
    name: 'comerciales',
    component: () => import(/* webpackChunkName: "assessors" */ './views/Commercial/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/comercial/:id?',
    name: 'comercial',
    props: true,
    component: () => import(/* webpackChunkName: "assessor" */ './views/Commercial/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/clientes',
    name: 'clientes',
    component: () => import(/* webpackChunkName: "clients" */ './views/Clients/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/cliente/:id?',
    name: 'cliente',
    props: true,
    component: () => import(/* webpackChunkName: "client" */ './views/Clients/Detail'),
    meta: {
      auth: true,
      roles: ['admin'],
    },
  },

  {
    path: '/finalidadinmuebles',
    name: 'finalidadinmuebles',
    component: () =>
      import(/* webpackChunkName: "propertyFinalities" */ './views/PropertyFinalities/List'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/finalidadinmueble/:id?',
    name: 'finalidadinmueble',
    props: true,
    component: () =>
      import(/* webpackChunkName: "propertyFinality" */ './views/PropertyFinalities/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/estadoinmuebles',
    name: 'estadoinmuebles',
    component: () =>
      import(/* webpackChunkName: "propertyStatuses" */ './views/PropertyStatuses/List'),
    meta: {
      auth: true,
      roles: ['admin'],
    },
  },

  {
    path: '/estadoinmueble/:id?',
    name: 'estadoinmueble',
    props: true,
    component: () =>
      import(/* webpackChunkName: "propertyStatus" */ './views/PropertyStatuses/Detail'),
    meta: {
      auth: true,
      roles: ['admin'],
    },
  },

  {
    path: '/creacion-agenda-de-visitas',
    name: 'scheduleAssessorVisits',
    component: () =>
      import(/* webpackChunkName: "scheduleAssessorVisits" */ './views/ScheduleAssessorVisits'),
    meta: {
      auth: true,
      roles: ['tasador', 'colaborador'],
    },
  },

  {
    path: '/agenda-de-visitas',
    name: 'visitsSchedule',
    component: () => import(/* webpackChunkName: "visitsSchedule" */ './views/VisitsSchedule'),
    meta: {
      auth: true,
      roles: ['tasador', 'colaborador'],
    },
  },

  {
    path: '/visitas',
    name: 'visits',
    component: () => import(/* webpackChunkName: "visits" */ './views/Visits'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },

  {
    path: '/zonas',
    name: 'zones',
    component: () => import(/* webpackChunkName: "zones" */ './views/Zones'),
    meta: {
      auth: true,
      roles: ['admin', 'colaborador'],
    },
  },
  {
    path: '/incidencias',
    name: 'incidencias',
    props: true,
    component: () => import(/* webpackChunkName: "incidents" */ './views/Incidents/List'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },
  {
    path: '/incidencia/:id?',
    name: 'incidencia',
    props: true,
    component: () => import(/* webpackChunkName: "incident" */ './views/Incidents/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },
  {
    path: '/retenidos',
    name: 'retenidos',
    props: true,
    component: () => import(/* webpackChunkName: "retaineds" */ './views/Retaineds/List'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },
  {
    path: '/retenido/:id?',
    name: 'retenido',
    props: true,
    component: () => import(/* webpackChunkName: "retained" */ './views/Retaineds/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },
  {
    path: '/revisiones',
    name: 'revisiones',
    props: true,
    component: () => import(/* webpackChunkName: "revisions" */ './views/Revisiones/List'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },
  {
    path: '/revision/:id?',
    name: 'revision',
    props: true,
    component: () => import(/* webpackChunkName: "revision" */ './views/Revisiones/Detail'),
    meta: {
      auth: true,
      roles: ['admin', 'tasador', 'colaborador'],
    },
  },
  {
    path: '/subir-documentacion',
    name: 'uploadDocuments',
    props: true,
    component: () => import(/* webpackChunkName: "uploadDocuments" */ './views/UploadChargeDocuments'),
    meta: {
      auth: true,
      roles: ['tasador', 'colaborador'],
    },
  },
  {
    path: '/codigos-postales',
    name: 'codigosPostales',
    props: true,
    component: () => import(/* webpackChunkName: "uploadDocuments" */ './views/CodigosPostales/List'),
    meta: {
      auth: true,
      roles: ['admin'],
    },
  },
  {
    path: '/codigo-postal/:id?',
    name: 'codigopostal',
    props: true,
    component: () => import(/* webpackChunkName: "revision" */ './views/CodigosPostales/Detail'),
    meta: {
      auth: true,
      roles: ['admin'],
    },
  },
  
];

const router = new Router({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  const { 'auth/isLoggedIn': loggedIn } = store.getters;
  const { roles = [] } = to.meta;

  const isProtectedRoute = to.matched.some(({ meta = {} }) => !!meta.auth);
  const isAllowed = isProtectedRoute ? store.getters['auth/can'](roles) : true;
  const isLoginRoute = to.matched.some(route => route.name === 'login');

  if (!loggedIn && isProtectedRoute) {
    next({ name: 'login' });
  } else if (loggedIn && (isLoginRoute || !isAllowed)) {
    next({ name: 'home' });
  } else {
    next();
  }
});

Vue.use(Router);

export default router;
